module.exports = __webpack_public_path__ + "img/res1.d6a613f3.gif";